import Vue, { PropType } from 'vue'
import { ExtendedVue } from 'vue/types/vue'

interface ViewModelData {}

interface ViewModelMethods {}

interface ViewModelComputed {
  show: boolean
}

interface ViewModelProps<TModel> {
  model: TModel
}

export function ViewModelBase<TModel> (): ExtendedVue<
  Vue,
  ViewModelData,
  ViewModelMethods,
  ViewModelComputed,
  ViewModelProps<TModel>,
  void
  > {
  return Vue.extend({
    name: 'ViewModelBase',

    props: {
      model: {
        type: Object as PropType<TModel>,
        required: true
      }
    },

    computed: {
      show (): boolean {
        return !!this.model
      }
    }
  })
}
